import { Abonent } from '@shared/types/osi/abonents';

export interface IOsiFlatOsvWidgetViewModel {
  isLoading: boolean;
  totalsOsv: any[];
  abonents: Abonent[];
  selectedAbonent: Abonent | null;
  rows: any[];
  periodsNumber: number;
  // Флаг «Свернуть дочерние помещения»
  isCollapseChildren: boolean;
  // Список помещений для выбора с учётом флага сворачивания
  visibleAbonents: Abonent[];
  // OSI-806: есть ли у ОСИ дочерние помещения (паркинги/кладовки).
  // Если нет — чекбокс «Свернуть дочерние помещения» не показываем.
  hasChildAbonents: boolean;
  loadAbonents: () => Promise<void>;
  loadOsv: () => Promise<void>;
  downloadOsv: () => Promise<void>;
  // Переключатель флага сворачивания дочерних помещений
  setCollapseChildren: (value: boolean) => void;
}

export const IOsiFlatOsvWidgetViewModelToken = Symbol.for('IOsiFlatOsvWidgetViewModel');
